import React, { useState, useEffect, useRef } from 'react';
import { apiClient } from '../../components/api/ApiClient';

const ALGORITHMS = [
    { label: 'الگو اول ( فروش )', value: 'First' },
    { label: 'الگو دوم ( فروش ارز )', value: 'Second' },
    { label: 'الگو سوم ( طلا،جواهر،پلاتین )', value: 'Third' },
    { label: 'الگو چهارم ( قرارداد پیمانکاری )', value: 'Fourth' },
    { label: 'الگو پنجم ( قبوض خدماتی )', value: 'Fifth' },
    { label: 'الگو ششم ( بلیط هواپیما )', value: 'Sixth' },
    { label: 'الگو هفتم ( صادرات )', value: 'Seventh' },
    { label: 'الگو هشتم ( بارنامه )', value: 'Eighth' },
    { label: 'الگو یازدهم ( بورس اوراق بهادار مبتنی بر کالا )', value: 'Eleventh' },
    { label: 'الگو سیزدهم ( فروش خدمات بیمه ای )', value: 'Thirteenth' },
];

const INVOICE_TYPES = [
    { label: 'صورت حساب کاغذی', value: 'Zero_type' },
    { label: 'نوع اول', value: 'First_type' },
    { label: 'نوع دوم', value: 'Second_type' },
    { label: 'نوع سوم', value: 'Third_type' },
];

function InvoiceFields() {
    const [fieldsConfig, setFieldsConfig] = useState([]);
    const [invoiceType, setInvoiceType] = useState('First_type');
    const [invoiceAlgo, setInvoiceAlgo] = useState('First');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [resetting, setResetting] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [defaultFieldsConfig, setDefaultFieldsConfig] = useState(null);

    const isFirstMount = useRef(true);
    const fieldsConfigRef = useRef([]);

    useEffect(() => {
        if (isFirstMount.current) {
            isFirstMount.current = false;
            fetchConfig();
        }
    }, []);


    useEffect(() => {
        if (!isFirstMount.current && invoiceType && invoiceAlgo) {
            fetchConfig();
        }
    }, [invoiceType, invoiceAlgo]);

    const normalizeFields = (input) => {
        if (Array.isArray(input)) return input;
        if (input && typeof input === 'object') {
            return Object.entries(input).map(([name, value]) => ({
                name,
                active: !!value.active,
                required: !!value.required,
                translate: value.translate || name,
            }));
        }
        return [];
    };

    const fetchConfig = async () => {
        setLoading(true);
        setError(null);
        try {
            const url = `/user-preferences/api/invoice-config/?typeOfInvoice=${invoiceType}&algoOfInvoice=${invoiceAlgo}`;
            const data = await apiClient(url, { method: 'GET' });
            if (data && data.fields_config !== undefined) {
                const normalizedFields = normalizeFields(data.fields_config);
                setFieldsConfig(normalizedFields);
                fieldsConfigRef.current = normalizedFields;


                if (data.invoiceType && data.invoiceType !== invoiceType) {
                    setInvoiceType(data.invoiceType);
                }
                if (data.invoiceAlgo && data.invoiceAlgo !== invoiceAlgo) {
                    setInvoiceAlgo(data.invoiceAlgo);
                }


                if (Array.isArray(data.fields_config)) {
                    const defaultObj = {};
                    data.fields_config.forEach(field => {
                        defaultObj[field.name] = {
                            active: field.active,
                            required: field.required,
                            translate: field.translate
                        };
                    });
                    setDefaultFieldsConfig(defaultObj);
                } else if (data.fields_config && typeof data.fields_config === 'object') {
                    setDefaultFieldsConfig(data.fields_config);
                }
            }
        } catch (err) {
            console.error('خطا در دریافت تنظیمات:', err);
            setError(err.message || 'خطا در دریافت تنظیمات');
        } finally {
            setLoading(false);
        }
    };

    const toggleField = (fieldName) => {
        setFieldsConfig(prev => {
            const updated = prev.map(field =>
                field.name === fieldName
                    ? { ...field, active: !field.active }
                    : field
            );
            fieldsConfigRef.current = updated;
            return updated;
        });
    };

    const handleReset = async () => {
        if (!defaultFieldsConfig) {
            setError('تنظیمات اولیه در دسترس نیست');
            return;
        }

        setResetting(true);
        setError(null);
        try {
            const resetPayload = {
                invoiceType: invoiceType,
                invoiceAlgo: invoiceAlgo,
                fields_config: defaultFieldsConfig,
                id: 440
            };

            const response = await apiClient('/user-preferences/api/invoice-config/', {
                method: 'GET',
                data: resetPayload
            });

            console.log('Response from reset:', response);


            await fetchConfig();
        } catch (err) {
            console.error('خطا در بازگشت به تنظیمات اولیه:', err);
            setError(err.message || 'خطا در بازگشت به تنظیمات اولیه');
        } finally {
            setResetting(false);
        }
    };

    const handleSave = async () => {
        setSaving(true);
        setError(null);
        setSuccess(null);
        try {

            const currentFields = fieldsConfigRef.current;

            const savePayload = {
                invoiceType: invoiceType,
                invoiceAlgo: invoiceAlgo,
                configItems: currentFields
            };

            console.log('Sending save payload:', JSON.stringify(savePayload, null, 2));

            const url = '/user-preferences/api/invoice-config/';

            const response = await apiClient(url, {
                method: 'POST',
                data: savePayload
            });

            console.log('Response from save:', response);


            await fetchConfig();

            setSuccess('تنظیمات با موفقیت ذخیره شد');
        } catch (err) {
            console.error('خطا در ذخیره تنظیمات:', err);
            setError(err.message || 'خطا در ذخیره تنظیمات');
        } finally {
            setSaving(false);
        }
    };

    const handleInvoiceTypeChange = (e) => {
        setInvoiceType(e.target.value);
    };

    const handleInvoiceAlgoChange = (e) => {
        setInvoiceAlgo(e.target.value);
    };

    const safeFields = Array.isArray(fieldsConfig) ? fieldsConfig : normalizeFields(fieldsConfig);


    const columns = [[], [], [], []];
    safeFields.forEach((field, index) => {
        columns[index % 4].push(field);
    });

    if (loading) {
        return (
            <div className="row">
                <div className="col-xl-12">
                    <div className="card stretch stretch-full">
                        <div className="card-body text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden text-dark">در حال بارگذاری...</span>
                            </div>
                            <p className="mt-3 text-dark">در حال بارگذاری تنظیمات...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card stretch stretch-full">
                    <div className="card-header">
                        <h5 className="card-title">تنظیمات فیلدهای صورتحساب</h5>
                    </div>
                    <div className="card-body">

                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={handleReset}
                                disabled={resetting}
                            >
                                {resetting ? 'در حال بازگشت...' : 'بازگشت به تنظیمات اولیه'}
                            </button>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSave}
                                disabled={saving}
                            >
                                {saving ? 'در حال ذخیره...' : 'ذخیره'}
                            </button>

                            <div className="d-flex gap-3 flex-wrap ms-auto">
                                <div style={{ minWidth: '200px' }}>
                                    <label className="form-label mb-1 small">الگو</label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={invoiceAlgo}
                                        onChange={handleInvoiceAlgoChange}
                                    >
                                        {ALGORITHMS.map(algo => (
                                            <option key={algo.value} value={algo.value}>
                                                {algo.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ minWidth: '150px' }}>
                                    <label className="form-label mb-1 small">نوع</label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={invoiceType}
                                        onChange={handleInvoiceTypeChange}
                                    >
                                        {INVOICE_TYPES.map(type => (
                                            <option key={type.value} value={type.value}>
                                                {type.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                {error}
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setError(null)}
                                ></button>
                            </div>
                        )}

                        {success && (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                {success}
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setSuccess(null)}
                                ></button>
                            </div>
                        )}


                        {safeFields.length === 0 ? (
                            <div className="text-center py-5 text-muted">
                                <p>هیچ فیلدی یافت نشد</p>
                            </div>
                        ) : (
                            <div className="row">
                                {columns.map((column, colIndex) => (
                                    <div key={colIndex} className="col-md-3">
                                        {column.map((field) => (
                                            <div
                                                key={field.name}
                                                className={`d-flex align-items-center mb-3 p-2 rounded cursor-pointer transition-all ${field.active
                                                    ? 'border border-2 border-success bg-soft-success'
                                                    : 'border border-1 border-secondary opacity-75 bg-light'
                                                    }`}
                                                onClick={() => toggleField(field.name)}
                                                style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                            >
                                                <div
                                                    className={`rounded-circle me-2 flex-shrink-0 ${field.active ? 'bg-success' : 'bg-secondary'
                                                        }`}
                                                    style={{
                                                        width: '10px',
                                                        height: '10px',
                                                        minWidth: '10px'
                                                    }}
                                                ></div>
                                                <span className={`small ${field.active ? 'text-dark fw-bold' : 'text-muted'}`} style={{ lineHeight: '1.5' }}>
                                                    {field.translate}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvoiceFields;
